module.exports = __webpack_public_path__ + "static/media/spinner.6cc04247.gif";